import React, { useState } from "react";
import { MultiSelect as MultiSelectDropdown } from "primereact/multiselect";
import { classNames } from "primereact/utils";

interface Option {
  label: string;
  value: any;
}

interface MultiSelectProps {
  id?: string;
  name?: string;
  value?: any[];
  options: Option[];
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  error?: string;
  label?: string;
  filter?: boolean;
  showClear?: boolean;
  selectAll?: boolean;
  maxSelectedLabels?: number;
  selectedItemsLabel?: string;
  optionLabel?: string;
  optionValue?: string;
  onChange?: (e: { value: any[] }) => void;
  onSelectAll?: (e: any) => void;
  onBlur?: (e: React.FocusEvent<HTMLElement>) => void;
  loading?: boolean;
  showSelectAll?: boolean;
}

export function MultiSelect({
  id,
  name,
  value,
  options,
  placeholder = "Select options",
  disabled = false,
  required = false,
  className,
  error,
  label,
  filter = true,
  showClear = false,
  showSelectAll = true,
  maxSelectedLabels = 3,
  selectedItemsLabel = "{0} items selected",
  optionLabel = "label",
  optionValue = "value",
  onChange,
  onBlur,
  loading = false,
  onSelectAll,
}: MultiSelectProps) {
  const inputId = id || name;
  const [selectAll, setSelectAll] = useState(false);

  return (
    <div className="field">
      {label && (
        <label htmlFor={inputId} className="block mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <MultiSelectDropdown
        id={inputId}
        name={name}
        loading={loading}
        value={loading ? [] : (value || [])}
        options={options}
        placeholder={loading ? "Loading..." : placeholder}
        disabled={disabled}
        filter={filter}
        showClear={showClear}
        selectAll={selectAll}
        showSelectAll={showSelectAll}
        onSelectAll={e => {
          setSelectAll(!e.checked);
          onSelectAll?.(e.checked ? [] : options.map(option => option.value));
        }}
        maxSelectedLabels={maxSelectedLabels}
        selectedItemsLabel={selectedItemsLabel}
        optionLabel={optionLabel}
        optionValue={optionValue}
        className={classNames("w-full", { "p-invalid": error }, className)}
        onChange={onChange}
        onBlur={onBlur}
      />
      {error && <small className="p-error block mt-1">{error}</small>}
    </div>
  );
}
